export type MicrositeImagesType =
  | 'VERTICAL'
  | 'HORIZONTAL'
  | 'GRID-1'
  | 'GRID-2'
  | 'GRID-3'
  | 'GRID-4'
  | 'GRID-5'
  | 'GRID-6';

export type MicrositeImageItem = {
  img?: string;
  image?: string;
  title?: string;
  cols?: number;
  rows?: number;
  height?: number;
};
export const getConvertImagesToGrid = (array: MicrositeImageItem[], type: MicrositeImagesType) => {
  if (type === 'HORIZONTAL') {
    return array.map((item) => {
      return { ...item, rows: 6, cols: 4 };
    });
  }

  if (type === 'GRID-1') {
    return array.map((item, index) => {
      if ((index + 1) % 3 !== 0) {
        return { ...item, rows: 1, cols: 2 };
      } else {
        return { ...item, rows: 3, cols: 4 };
      }
    });
  }

  if (type === 'GRID-2') {
    return array.map((item, index) => {
      if ((index + 1) % 3 === 1) {
        return { ...item, rows: 3, cols: 4 };
      } else {
        return { ...item, rows: 1, cols: 2 };
      }
    });
  }

  if (type === 'GRID-3') {
    return array.map((item, index) => {
      const positionInCycle = (index % 5) + 1;
      if (positionInCycle !== 2 && positionInCycle !== 5) {
        return { ...item, rows: 2, cols: 1, height: '74.5px' };
      } else {
        return { ...item, rows: 4, cols: 3, height: '165px' };
      }
    });
  }

  if (type === 'GRID-4') {
    return array.map((item, index) => {
      const positionInCycle = (index % 7) + 1;
      if (positionInCycle !== 1 && positionInCycle !== 4) {
        return { ...item, rows: 2, cols: 1, height: '74.5px' };
      } else {
        return { ...item, rows: 4, cols: 3, height: '165px' };
      }
    });
  }

  if (type === 'GRID-5') {
    return array.map((item, index) => {
      const positionInCycle = (index % 4) + 1;
      if (positionInCycle !== 1 && positionInCycle !== 2) {
        return { ...item, rows: 1, cols: 2 };
      } else {
        return { ...item, rows: 3, cols: 2 };
      }
    });
  }

  if (type === 'GRID-6') {
    return array.map((item) => {
      return { ...item, rows: 2, cols: 2 };
    });
  }
};
